import { render, staticRenderFns } from "./DTCHome.vue?vue&type=template&id=8341c678&"
import script from "./DTCHome.vue?vue&type=script&lang=js&"
export * from "./DTCHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports